class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

const gridItems = document.querySelectorAll('.grid__item[available="false"]');

cookie_date = new Date($.cookie("delivery_date") + "T00:00:00");
coming_date = new Date(
  $("#current_delivery_date").attr("date") + "T00:00:00"
);
currentDate = new Date();
 isWithinTimeRange = false;

// Check if the current date is a Friday after 5pm or a Saturday or Sunday before 3pm
if (
  (currentDate.getDay() === 5 && currentDate.getHours() >= 17) ||
  (currentDate.getDay() === 6 || currentDate.getDay() === 0)
) {
  isWithinTimeRange = true;
}
new_customer = $("#new-cust").val();
 showAllProducts = false;

if (new_customer == "false" && isWithinTimeRange == true && $('#late_cutoff').val() == "false") {
  showAllProducts = true;
}

console.log("Is within time range:", isWithinTimeRange);
cookie_date_utc = cookie_date.toUTCString();
coming_date_utc = coming_date.toUTCString();


if (cookie_date_utc == coming_date_utc && showAllProducts == false) {
  current_week = true;
} else {
  current_week = false;
}

if (current_week == true) {
gridItems.forEach((item) => {
  item.style.display = 'none';
});
}
